import i18n from "@/i18n";

export default {
  alterNativeFuel: [
    {
      label: "B5",
      value: "B5",
    },
    {
      label: "B100",
      value: "B100",
    },
    {
      label: "GTL燃料",
      value: "GTL",
    },
  ],
  alterNativeEnergy: [
    {
      label: "太陽光",
      value: "SolarPanelsOnSite",
    },
    {
      label: "風力",
      value: "WindPowerGeneration",
    },
  ],
  utilizationOfElectricityMenus: [
    {
      label: "活用していない",
      value: "活用していない",
    },
    {
      label: "100%再エネ",
      value: "100%再エネ",
    },
    {
      label: "CO2フリー電力（原子力価値メニュー含む)",
      value: "CO2フリー電力（原子力価値メニュー含む)",
    },
    { label: "グリーン電力証書", value: "グリーン電力証書" },
    { label: "再エネクレジット", value: "再エネクレジット" },
  ],
  leftTurnOffLight: [
    { key: 0, value: i18n.tc("diaryList.co2Input.leftTurnOffLight.percent20") },
    {
      key: 1,
      value: i18n.tc("diaryList.co2Input.leftTurnOffLight.percent2040"),
    },
    {
      key: 2,
      value: i18n.tc("diaryList.co2Input.leftTurnOffLight.percent4060"),
    },
    {
      key: 3,
      value: i18n.tc("diaryList.co2Input.leftTurnOffLight.percent6080"),
    },
    { key: 4, value: i18n.tc("diaryList.co2Input.leftTurnOffLight.percent80") },
  ],
  leftHigtEffiencyLumi: [
    { key: 0, value: i18n.tc("diaryList.co2Input.higtEffiencyLumi.percent60") },
    {
      key: 1,
      value: i18n.tc("diaryList.co2Input.higtEffiencyLumi.percent6070"),
    },
    {
      key: 2,
      value: i18n.tc("diaryList.co2Input.higtEffiencyLumi.percent7080"),
    },
    {
      key: 3,
      value: i18n.tc("diaryList.co2Input.higtEffiencyLumi.percent8090"),
    },
    { key: 4, value: i18n.tc("diaryList.co2Input.higtEffiencyLumi.percent90") },
  ],
  electricityMenus: [
    { key: 0, value: i18n.tc("diaryList.co2Input.electricityMenus.disable") },
    {
      key: 1,
      value: i18n.tc("diaryList.co2Input.electricityMenus.100renewableEnergy"),
    },
    {
      key: 2,
      value: i18n.tc("diaryList.co2Input.electricityMenus.CO2FreePower"),
    },
    {
      key: 3,
      value: i18n.tc("diaryList.co2Input.electricityMenus.greenPower"),
    },
    {
      key: 4,
      value: i18n.tc("diaryList.co2Input.electricityMenus.reEnegyCredit"),
    },
  ],
  waterIntakeMenus: [
    {
      key: 0,
      value: i18n.tc("diaryList.co2Input.waterIntakeMenus.notAggregated"),
    },
    { key: 1, value: i18n.tc("diaryList.co2Input.waterIntakeMenus.tapWater") },
    {
      key: 2,
      value: i18n.tc("diaryList.co2Input.waterIntakeMenus.industrialWater"),
    },
    { key: 3, value: i18n.tc("diaryList.co2Input.waterIntakeMenus.spring") },
    {
      key: 4,
      value: i18n.tc("diaryList.co2Input.waterIntakeMenus.groundWater"),
    },
    { key: 5, value: i18n.tc("diaryList.co2Input.waterIntakeMenus.seaWater") },
    {
      key: 6,
      value: i18n.tc("diaryList.co2Input.waterIntakeMenus.riverWater"),
    },
    { key: 7, value: i18n.tc("diaryList.co2Input.waterIntakeMenus.others") },
  ],
  drainageDestinationMenus: [
    {
      key: 0,
      value: i18n.tc(
        "diaryList.co2Input.drainageDestinationMenus.notAggregated"
      ),
    },
    {
      key: 1,
      value: i18n.tc("diaryList.co2Input.drainageDestinationMenus.waterworks"),
    },
    {
      key: 2,
      value: i18n.tc(
        "diaryList.co2Input.drainageDestinationMenus.measuredValue"
      ),
    },
    {
      key: 3,
      value: i18n.tc("diaryList.co2Input.drainageDestinationMenus.waterways"),
    },
    {
      key: 4,
      value: i18n.tc("diaryList.co2Input.drainageDestinationMenus.riverNLakes"),
    },
    {
      key: 5,
      value: i18n.tc("diaryList.co2Input.drainageDestinationMenus.ocean"),
    },
    {
      key: 6,
      value: i18n.tc(
        "diaryList.co2Input.drainageDestinationMenus.agricultural"
      ),
    },
    {
      key: 7,
      value: i18n.tc("diaryList.co2Input.drainageDestinationMenus.others"),
    },
  ],
  middleOfficeTemperature: [
    { key: 0, value: i18n.tc("diaryList.co2Input.officeTemperature.percent") },
    {
      key: 1,
      value: i18n.tc("diaryList.co2Input.officeTemperature.percent20"),
    },
    {
      key: 2,
      value: i18n.tc("diaryList.co2Input.officeTemperature.percent2040"),
    },
    {
      key: 3,
      value: i18n.tc("diaryList.co2Input.officeTemperature.percent4060"),
    },
    {
      key: 4,
      value: i18n.tc("diaryList.co2Input.officeTemperature.percent6080"),
    },
    {
      key: 5,
      value: i18n.tc("diaryList.co2Input.officeTemperature.percent80"),
    },
  ],
  middleAirCondition: [
    { key: 0, value: i18n.tc("diaryList.co2Input.airCondition.percent") },
    { key: 1, value: i18n.tc("diaryList.co2Input.airCondition.percent30") },
    { key: 2, value: i18n.tc("diaryList.co2Input.airCondition.percent3050") },
    { key: 3, value: i18n.tc("diaryList.co2Input.airCondition.percent5070") },
    { key: 4, value: i18n.tc("diaryList.co2Input.airCondition.percent7090") },
    { key: 5, value: i18n.tc("diaryList.co2Input.airCondition.percent90") },
  ],
  middleFuelSaving: [
    { key: 0, value: i18n.tc("diaryList.co2Input.fuelSaving.percent") },
    { key: 1, value: i18n.tc("diaryList.co2Input.fuelSaving.percent10") },
    { key: 2, value: i18n.tc("diaryList.co2Input.fuelSaving.percent1020") },
    { key: 3, value: i18n.tc("diaryList.co2Input.fuelSaving.percent2030") },
    { key: 4, value: i18n.tc("diaryList.co2Input.fuelSaving.percent3040") },
    { key: 5, value: i18n.tc("diaryList.co2Input.fuelSaving.percent40") },
  ],
  middleEngineStop: [
    { key: 0, value: i18n.tc("diaryList.co2Input.engineStop.percent") },
    { key: 1, value: i18n.tc("diaryList.co2Input.engineStop.percent20") },
    { key: 2, value: i18n.tc("diaryList.co2Input.engineStop.percent2040") },
    { key: 3, value: i18n.tc("diaryList.co2Input.engineStop.percent4060") },
    { key: 4, value: i18n.tc("diaryList.co2Input.engineStop.percent6080") },
    { key: 5, value: i18n.tc("diaryList.co2Input.engineStop.percent80") },
  ],
  middleInspectionMainternace: [
    {
      key: 0,
      value: i18n.tc("diaryList.co2Input.inspectionMainternace.percent"),
    },
    {
      key: 1,
      value: i18n.tc("diaryList.co2Input.inspectionMainternace.percent20"),
    },
    {
      key: 2,
      value: i18n.tc("diaryList.co2Input.inspectionMainternace.percent2040"),
    },
    {
      key: 3,
      value: i18n.tc("diaryList.co2Input.inspectionMainternace.percent4060"),
    },
    {
      key: 4,
      value: i18n.tc("diaryList.co2Input.inspectionMainternace.percent6080"),
    },
    {
      key: 5,
      value: i18n.tc("diaryList.co2Input.inspectionMainternace.percent80"),
    },
  ],
  middleGuideFuelSaving: [
    { key: 0, value: i18n.tc("diaryList.co2Input.heavyOilFuelSaving.percent") },
    {
      key: 1,
      value: i18n.tc("diaryList.co2Input.heavyOilFuelSaving.percent20"),
    },
    {
      key: 2,
      value: i18n.tc("diaryList.co2Input.heavyOilFuelSaving.percent2040"),
    },
    {
      key: 3,
      value: i18n.tc("diaryList.co2Input.heavyOilFuelSaving.percent4060"),
    },
    {
      key: 4,
      value: i18n.tc("diaryList.co2Input.heavyOilFuelSaving.percent6080"),
    },
    {
      key: 5,
      value: i18n.tc("diaryList.co2Input.heavyOilFuelSaving.percent80"),
    },
  ],
  tooltipMess: {
    electricity: {
      lunchBreakDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.electric.lunchBreakDescribe"
      ),
      useOfHighEfficiencyLuminairesDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.electric.useOfHighEfficiencyLuminairesDescribe"
      ),
      officeRoomTemperatureDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.electric.officeRoomTemperatureDescribe"
      ),
      amountToUseDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.electric.amountToUseDescribe"
      ),
      utilizationOfElectricityMenusDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.electric.utilizationOfElectricityMenusDescribe"
      ),
    },
    water: {
      waterIntakeDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.water.waterIntakeDescribe"
      ),
      drainageDestinationDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.water.drainageDestinationDescribe"
      ),
      displacementDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.water.displacementDescribe"
      ),
      waterAmount: i18n.tc("diaryList.co2Input.tooltip.water.waterAmount"),
      waterTransfer: i18n.tc("diaryList.co2Input.tooltip.water.waterTransfer"),
    },
    order: {
      heavyMachineB5Describe: i18n.tc(
        "diaryList.co2Input.tooltip.order.heavyMachineB5Describe"
      ),
      heavyMachineB100Describe: i18n.tc(
        "diaryList.co2Input.tooltip.order.heavyMachineB100Describe"
      ),
      solarPanelDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.order.solarPanelDescribe"
      ),
      windPowerDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.order.windPowerDescribe"
      ),
      useGTLFuelDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.order.useGTLFuelDescribe"
      ),
      renewableEnergyDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.order.renewableEnergyDescribe"
      ),
      flyAshDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.order.flyAshDescribe"
      ),
    },
    kerosene: {
      roomTemperatureDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.kerosene.roomTemperatureDescribe"
      ),
      airConditionDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.kerosene.airConditionDescribe"
      ),
      amountUseDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.kerosene.amountUseDescribe"
      ),
    },
    lightOil: {
      idlingStopDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.lightOil.idlingStopDescribe"
      ),
      checkPeriodicInpectionDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.lightOil.checkPeriodicInpectionDescribe"
      ),
      lectureGuidanceFuelDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.lightOil.lectureGuidanceFuelDescribe"
      ),
      implementationFuelEffientVerificationDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.lightOil.implementationFuelEffientVerificationDescribe"
      ),
    },
    heavyOil: {
      idlingStopDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.heavyOil.idlingStopDescribe"
      ),
      properMaintenanceDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.heavyOil.properMaintenanceDescribe"
      ),
      lectureGuidanceFuelDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.heavyOil.lectureGuidanceFuelDescribe"
      ),
      amountUseDescribe: i18n.tc(
        "diaryList.co2Input.tooltip.heavyOil.amountUseDescribe"
      ),
    },
  },
  configHTML2Canvas: {
    margin: [0.3, 0.2, 0.4, 0], //[top, left, bottom, right].
    filename: "CO2DOC.pdf",
    image: { type: "jpg", quality: 0.7 },
    html2canvas: {
      scale: 1,
      letterRendering: true,
      useCORS: true,
      allowTaint: false,
      logging: true,
      removeContainer: false,
    },
    jsPDF: { unit: "in", format: "a4", orientation: "l" },
    pagebreak: { mode: "css", avoid: ".html2canvas-page-break" },
  },
  oldMachines: [
    { label: "ダンプトラック (10t未満)", layers: { oldMachineFirstLayer: "9901", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "ダンプトラック (10t以上)", layers: { oldMachineFirstLayer: "9901", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "トラック (4t未満)", layers: { oldMachineFirstLayer: "9902", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "トラック (4t以上)", layers: { oldMachineFirstLayer: "9902", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "重ダンプトラック (32t未満)", layers: { oldMachineFirstLayer: "9903", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "重ダンプトラック (32t以上)", layers: { oldMachineFirstLayer: "9903", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "バックホー (1m3未満)", layers: { oldMachineFirstLayer: "9904", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "バックホー (1m3未満ハイブリッド)", layers: { oldMachineFirstLayer: "9904", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "バックホー (1m3以上)", layers: { oldMachineFirstLayer: "9904", oldMachineSecondLayer:  "001", oldMachineThirdLayer: "001-003" }},
    { label: "ミニバックホー", layers: { oldMachineFirstLayer: "9905", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "ブルドーザー (10t未満)", layers: { oldMachineFirstLayer: "9906", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "ブルドーザー (10t以上)", layers: { oldMachineFirstLayer: "9906", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "トラクタショベル (クラローダ)", layers: { oldMachineFirstLayer: "9907", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "ホイルローダ (4m3未満)", layers: { oldMachineFirstLayer: "9908", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "ホイルローダ (4m3以上)", layers: { oldMachineFirstLayer: "9908", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "ロードローラ", layers: { oldMachineFirstLayer: "9909", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "基礎杭・掘削機械 (ｸﾛｰﾗ式杭打機)", layers: { oldMachineFirstLayer: "9910", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "基礎杭・掘削機械 (ｸﾛｰﾗ式アースオーガ)", layers: { oldMachineFirstLayer: "9910", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "基礎杭・掘削機械 (ｸﾛｰﾗ式地下連壁)", layers: { oldMachineFirstLayer: "9910", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-003" }},
    { label: "クラムシェル (1m3未満)", layers: { oldMachineFirstLayer: "9911", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "クラムシェル (1m3以上)", layers: { oldMachineFirstLayer: "9911", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "トラッククレーン (50t吊り未満)", layers: { oldMachineFirstLayer: "9912", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "トラッククレーン (50t吊り以上)", layers: { oldMachineFirstLayer: "9912", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "ラフタークレーン (20t吊り未満)", layers: { oldMachineFirstLayer: "9913", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "ラフタークレーン (20t吊り以上)", layers: { oldMachineFirstLayer: "9913", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "クローラクレーン (50t吊り未満)", layers: { oldMachineFirstLayer: "9914", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "クローラクレーン (50t吊り以上)", layers: { oldMachineFirstLayer: "9914", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "フォークリフト (2t吊り未満)", layers: { oldMachineFirstLayer: "9915", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "フォークリフト (2t吊り以上)", layers: { oldMachineFirstLayer: "9915", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "コンクリートポンプ車 (50m3未満)", layers: { oldMachineFirstLayer: "9916", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "コンクリートポンプ車 (50m3以上)", layers: { oldMachineFirstLayer: "9916", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "高所作業車 (ブーム型)", layers: { oldMachineFirstLayer: "9917", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "高所作業車 (垂直型)", layers: { oldMachineFirstLayer: "9917", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "発電機 (50kVA未満)", layers: { oldMachineFirstLayer: "9918", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "発電機 (50~149kVA)", layers: { oldMachineFirstLayer: "9918", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }},
    { label: "発電機 (150kVA以上)", layers: { oldMachineFirstLayer: "9918", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-003" }},
    { label: "空気圧縮機 (100kw未満)", layers: { oldMachineFirstLayer: "9919", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-001" }},
    { label: "空気圧縮機 (100kw以上)", layers: { oldMachineFirstLayer: "9919", oldMachineSecondLayer: "001", oldMachineThirdLayer: "001-002" }}
  ]
};
